import React, { ReactNode } from 'react'

import { FormattedOption, Select } from '@rmwc/select'
import '@rmwc/select/styles'
import styled from 'styled-components'
import { width } from 'styled-system'

interface Props {
  children?: ReactNode
  disabled?: boolean
  helpText?: string
  invalid?: boolean
  label?: string
  name?: string
  options?: FormattedOption[] | string[] | { [value: string]: string }
  placeholder?: string
  readOnly?: boolean
  required?: boolean
  value?: string
  width?: number | string
  onChange?(event: React.ChangeEvent<HTMLSelectElement>): void
}

const StyledSelect = styled(Select)`
  ${width};
  && {
    &.mdc-select--focused:not(.mdc-text-field--disabled) {
      .mdc-floating-label {
        color: ${(props) => `${props.theme.colors.primary} !important`};
      }

      .mdc-select__dropdown-icon {
        color: ${(props) => props.theme.colors.primary};
      }
    }
  }
`

const ThemedSelectField = ({ children, ...props }: Props) => {
  return (
    <StyledSelect outlined {...props}>
      {children}
    </StyledSelect>
  )
}

ThemedSelectField.displayName = 'SelectField'

ThemedSelectField.defaultProps = {
  width: '100%',
}

export default React.memo(ThemedSelectField)
